import React from 'react';
import { IconButton, Typography } from '@guildeducationinc/recess';
import AccessTimeIcon from '@guildeducationinc/recess/icons/AccessTimeIcon';
import DeleteOutlineIcon from '@guildeducationinc/recess/icons/DeleteOutlineIcon';
import styles from './RecentSearchesItem.module.scss';

interface Props {
	item: { id: string; label: string };
	onRemove: (id: string) => void;
	refine: (value: string) => void;
}

export const RecentSearchesItem: React.FC<Props> = ({ item, onRemove, refine }) => {
	return (
		<div
			className='aa-ItemWrapper'
			onClick={() => refine(item.label)}
			onKeyDown={e => {
				if (e.key === 'Enter') {
					refine(item.label);
				}
			}}
			role='button'
			tabIndex={0}
		>
			<div className='aa-ItemContent'>
				<AccessTimeIcon className={styles.icon} size={24} />
				<Typography variant='body1'>{item.label}</Typography>
			</div>
			<div className='aa-ItemActions'>
				<IconButton
					appearance='minimal'
					icon={<DeleteOutlineIcon size={24} />}
					label={`Remove search item ${item.label}`}
					onClick={e => {
						e.preventDefault();
						e.stopPropagation();
						onRemove(item.id);
					}}
				/>
			</div>
		</div>
	);
};
